const dev = require('@ecomm/bootstrapping/features/static/dev.json');
const production = require('@ecomm/bootstrapping/features/static/production.json');
const uat = require('@ecomm/bootstrapping/features/static/uat.json');

export const datafiles = { dev, uat, production };
